import { render } from "./InputCheckBox.vue?vue&type=template&id=4fb043b2&scoped=true&ts=true"
import script from "./InputCheckBox.vue?vue&type=script&lang=ts"
export * from "./InputCheckBox.vue?vue&type=script&lang=ts"

import "./InputCheckBox.vue?vue&type=style&index=0&id=4fb043b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb043b2"]])

export default __exports__